/* globals elkitorg_config */

import { node_observable_component } from 'common/util/ComponentDecorator';
import './about-company-page.scss';

@node_observable_component
export default class AboutCompanyPage {
	static classname = 'about-company-page';

	constructor($page) {
		this.$page = $page;

		this.init();
	}

	init = () => {
			this.initVideo();
	};

	initVideo = () => {
		const videoBoxes = document.querySelectorAll('#video-box');

		videoBoxes.forEach( box => {
			const play = box.querySelector('#play');
			const video = box.querySelector('#video');

			play.addEventListener('click', () => {
				if (video.paused) {
					video.play();
					video.setAttribute('controls', 'controls');
					play.classList.add('hidden');
				} else {
					video.pause();
					play.classList.remove('hidden');
				}
			});

			video.addEventListener('pause', () => {
				play.classList.remove('hidden');
			});

			video.addEventListener('play', () => {
				play.classList.add('hidden');
			});
		})
	}
};
